module.exports = __webpack_public_path__ + "static/logo-d19bb2bd56d040bda8c0bb4ea3cc129a.png";